// extracted by mini-css-extract-plugin
module.exports = {"root":"YYlhDN8l","timeLabel":"FWNsupGt","asOfLastCloseLabel":"SlpiCLwM","marketOpenWrapper":"P8ayJGt6","marketOpenLabel":"wIHqLwAK","liveDataLabel":"WObGlfOg"};